<template>
  <Modal
    :mask-closable="false"
    :title="title"
    :loading="modalLoding"
    v-model="modalStatusData.state"
    @on-ok="handleOnOk"
    @on-visible-change="handleVisibleChange">
    <Form
      ref="formValidateRule"
      :model="formModel"
      :rules="formRule"
      :label-width="100">
      <!-- <FormItem label="请在「我的导出」中查看或下载文件">
      </FormItem> -->
      <div class="form-tip">请在「我的导出」中查看或下载文件</div>
      <FormItem label="文件名称" prop="name">
        <!-- <Input
            @on-blur="(event)=>{
                if(event.target.value.substring(0,event.target.value.indexOf('.'))!==-1){
                    event.target.value = event.target.value.substring(0,event.target.value.indexOf('.')==-1?event.target.value.length:event.target.value.indexOf('.'));

                    formModel.name = event.target.value.substring(0,event.target.value.indexOf('.')==-1?event.target.value.length:event.target.value.indexOf('.'));
                }else{
                    event.target.value = event.target.value;
                    formModel.name = event.target.value;
                }
            }"
            @on-keyup="(event)=>{
                    event.target.value = event.target.value.substring(0,event.target.value.indexOf('.')==-1?event.target.value.length:event.target.value.indexOf('.'));

                    formModel.name = event.target.value.substring(0,event.target.value.indexOf('.')==-1?event.target.value.length:event.target.value.indexOf('.'));

            }"
            @on-change="handleFileName"
            placeholder="请输入文件名称"
            v-model="formModel.name"></Input> -->
        <Input
          placeholder="请输入文件名称"
          v-model="formModel.name"></Input>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
  import rlue from '@/validateRule/export/export';

  export default {
    name:'export-modal',
    props:{
      title:{
        type:String,
        default:''
      },
      modalStatusData:{
        type:Object,
        default:()=>{return {}}
      },
      formModel:{
        type:Object,
        default:()=>{return {}}
      }
    },
    data(){
      return{
        formRule:rlue,
        modalLoding:true,
        isrefresh:true
      }
    },
    methods:{
      handleOnOk(){
        let status = this.handleOk();
        if(status){
          this.$emit('select-on-ok',this.formModel);
        }else{
          this.changeLoding();
        }
      },
      handleVisibleChange(btn){
        if(!btn){
          this.$refs.formValidateRule.resetFields();
        }
        this.$emit('select-visible-change');
      },
      handleOk(){
        let status
        this.$refs['formValidateRule'].validate(valid => {
          status = valid;
        });
        return status;

      },
      //手动关闭模态框
      changeLoding(){
        this.modalLoding = false;
        this.$nextTick(()=>{
          this.modalLoding = true;
        })
      },
      handleFileName(event){
        this.formModel.name = event.target.value.substring(0,event.target.value.indexOf('.')==-1?event.target.value.length:event.target.value.indexOf('.'));
      }
    }
  }
</script>

<style lang="less">
  .form-tip{
    margin: 0 0 20px 20px;
    font-size: 14px;
    color: #9EA7B4;
  }
</style>
